
import config from 'config'
import { currentStoreView } from '@vue-storefront/core/lib/multistore'
import { TaskQueue } from '@vue-storefront/core/lib/sync'

export const getProductFromPan = (warrantyData) => {
  const {storeCode } = currentStoreView()
  const url = `${config.api.url}/api/ext/warranty/check?token={{token}}`
  return TaskQueue.execute({
    url,
    payload: {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      mode: 'cors',
      body: JSON.stringify({...warrantyData, storeCode})
    },
    silent: true
  }).then(res => {
    if (res.code !== 200) {
      throw new Error(JSON.stringify(res))
    }
    return res.result
  })
}
